import { useCallback, useContext } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ServiceContext } from '@msx/platform-services';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
  }
});
appInsights.loadAppInsights();

const useLogScreenMetrics = () => {
  const { authClient } = useContext(ServiceContext);

  const log = useCallback(async (pageName: string) => {
    const user = await authClient.getUser();
    const userEmail = user.email;
    const width = window.innerWidth;
    const height = window.innerHeight;
    const devicePixelRatio = window.devicePixelRatio;

    const screenDetails = {
      userEmail: userEmail,
      page: pageName,
      windowInnerWidth: width.toString(),
      windowInnerHeight: height.toString(),
      scale: devicePixelRatio.toString(),
      resolution: `${window.screen.width * devicePixelRatio}x${window.screen.height * devicePixelRatio}`,
      timestamp: new Date().toISOString(),
    };

    appInsights.trackEvent({
      name: 'ScreenResolution',
      properties: screenDetails,
    });
  }, [authClient]); // memoized only if authClient changes

  return log;
};

export default useLogScreenMetrics;
